import React, { Fragment, useCallback, useEffect } from "react";
import { Container } from "../components";
import { PartnerOffering } from "../data/partner_offering";
import { useQueryString } from "../hooks";
import { Locale } from "../lib/i18n/i18n_provider";
import { Spacer } from "../offering/spacer";
import { OfferingParams } from "../offering/template_offering_checkout_common";
import { useAnalytics } from "../lib/analytics/analytics";

interface PromoCodeBoxProps {
  partnerOffering: PartnerOffering;
  spaceID: string | undefined;
  locale: Locale;
}

const PromoCodeBox = (props: PromoCodeBoxProps) => {
  const locationPromoCodeBoxContent =
    props.partnerOffering?.offeringLocations.find(
      (ol) => ol.spaceID === props.spaceID
    )?.promoCodeBoxContent;
  const promoCodeBoxContent =
    locationPromoCodeBoxContent ||
    props.partnerOffering?.promoCodeBoxContent ||
    "";
  const queryString = useQueryString<OfferingParams>();
  /** This function to find the URL in the Promo Content
   * and add additional params (fromCatalog) to the existed URL
   */
  const contentClickHandler = useCallback(
    (e: any) => {
      const targetLink = e.target.closest("a");
      if (!targetLink) return;
      e.preventDefault();
      const queryParams = new URLSearchParams();
      if (queryString.fromCatalog) {
        queryParams.append("fromCatalog", queryString.fromCatalog);
      }
      window.location.assign(`${targetLink.href}?${queryParams}`);
    },
    [queryString.fromCatalog]
  );

  const analytics = useAnalytics();

  const onLinkClick = useCallback(
    (e) => {
      analytics.event(
        "Promotion Box Link Click",
        {
          "Promotion Call Box": e.target.href,
          Source: "WL",
        },
        { onlyProviders: ["mixpanel", "customerio"] }
      );
    },
    [analytics]
  );

  useEffect(() => {
    if (!promoCodeBoxContent) {
      return;
    }

    const containerEl = document.getElementById(
      "template-offering-details-base-offering-promo"
    );

    if (!containerEl) return;

    const linkEl = containerEl.querySelector("a");

    if (!linkEl) return;

    // mousedown is to track normal clicks as well as middle mouse click
    linkEl.addEventListener("mousedown", onLinkClick);
  }, [onLinkClick, promoCodeBoxContent]);

  if (!promoCodeBoxContent) {
    return null;
  }

  return (
    <Fragment>
      <Spacer size={16} />
      <div
        className={`template-offering-details-base-offering-promo text text-size-md text-${props.locale.baseLanguageTag}`}
        id={"template-offering-details-base-offering-promo"}
      >
        <Container paddingVertical={8} paddingHorizontal={16}>
          <div
            onClick={contentClickHandler}
            dangerouslySetInnerHTML={{
              __html: promoCodeBoxContent,
            }}
          />
        </Container>
      </div>
    </Fragment>
  );
};

export default PromoCodeBox;
